<template>
  <label :style="[{width}, height?{height}:{}]">
    <select v-model="value" :style="[{width}, {paddingInline: padding}, color?{color, borderColor: color, fontWeight: '400'}:{}, align?{textAlign: align}:{}, height?{height}:{}]">
    <slot/>
    </select>
  </label>
</template>

<script>
export default {
  props: ['defaultValue', 'width', 'color', 'padding', 'align', 'height'],
  data () {
    return {
      value: null
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  watch: {
    defaultValue () {
      console.log('defaultValue changed', this.value, this.defaultValue)
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
select {
  height: 40px;
  border-radius: 5px;
  border:1px solid var(--color-checked);
  box-sizing: border-box;
  padding-inline: 1em;
  color: var(--color-checked);
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  appearance: none;
  background-color: transparent;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
label {
  margin: 0;
  z-index: 1;
  height: 40px;
  position: relative;
  background-color: #FFFFFF;
  display: inline-flex;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color:var(--color-checked);
    mask-image: url(./svg/checkbox/arrowDown.svg);
    mask-repeat: no-repeat;
    mask-position:calc(100% - 15px) center;
    mask-size: 18px 14px;
    z-index: 1;
  }
}
</style>
